import ThemeProviderContext from './context';
import { useTheme } from './_hooks';

const ThemeProvider = ({ children }) => {
  const { theme, resolvedTheme, setTheme } = useTheme();
  return <ThemeProviderContext.Provider value={{ theme, resolvedTheme, setTheme }}>{children}</ThemeProviderContext.Provider>;
};

export default ThemeProvider;
